import React, { useEffect } from "react";

import BannerSection from '../../shared/components/BannerSection/BannerSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import ProductDescription from '../../shared/components/ProductDescription/ProductDescription';
import Faq from '../components/Faq/Faq';


import aboutUsBannerImg from '../../utils/assets/aboutUs/lockdown-hackers.png';
import idRegisterImg from '../../utils/assets/aboutUs/id-register.png';


const AboutUs = props => {
   useEffect(()=>{
      window.scroll(0,0);
   },[])
    const bannerSectionInfo =
     {
        cardTitle: "Managing the protection of your personal information has never been easier",
        cardButtonText: "Join us",
        lengendBackground: aboutUsBannerImg
     }

     const productDescription = {
        title : "Learn more about us",
        img : idRegisterImg
     }
          
    return(
        <React.Fragment>
           <BannerSection props={bannerSectionInfo}/>
           <NavegationInfo page="About us"/>
           <ProductDescription props={productDescription} />
            {/* <SectionInfo title={'FQA'} color={'#0f60bd'}/> */}
           <Faq/>
        </React.Fragment>
    );
};

export default AboutUs;